export const DetailTypeTranslations: { [key: string]: string } = {
  Default: "custom-project-properties.edit.type.selection",
  Text: "custom-project-properties.type-options.text",
  Number: "custom-project-properties.type-options.number",
  Dropdown: "custom-project-properties.type-options.dropdown",
  Date: "custom-project-properties.type-options.date",
  Time: "custom-project-properties.type-options.time",
};

export const DetailType: { [key: string]: number } = {
  Default: 0,
  Text: 1,
  Number: 2,
  Dropdown: 3,
  Date: 4,
  Time: 5,
};
